import {
  GET_GLOBAL_SETTINGS_SUCCESS,
  GlobalSettingsAction,
  UPDATE_GLOBAL_SETTINGS_SUCCESS
} from './global-settings.actions';

export interface IGlobalSettingsState {
  popupDisplayLimit?: number;
}

export const initialState: IGlobalSettingsState = {};

export function globalSettingsReducer(state = initialState, action: GlobalSettingsAction): IGlobalSettingsState {
  switch (action.type) {
    case GET_GLOBAL_SETTINGS_SUCCESS:
      return action.payload;
    case UPDATE_GLOBAL_SETTINGS_SUCCESS:
      return action.payload;
    default: {
      return state;
    }
  }
}

export const getGlobalSettingsSelector = state => state.leadGeneration.globalSettings;
